import Svg, { G } from 'react-native-svg'

export const UpiIcon = ({ size, selected }: { size: number; selected: boolean }) => {
  if (selected) {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24">
        <defs>
          <clipPath id="clip-UPI-color">
            <rect width={size} height={size} />
          </clipPath>
        </defs>
        <G id="UPI-color" clip-path="url(#clip-UPI-color)">
          <G id="UPI-grey" transform="translate(-336 491)">
            <path
              id="Path_401"
              data-name="Path 401"
              d="M10.484-21.628,4.913-2.755l10.794-9.573Z"
              transform="translate(340 -467)"
              fill="#2b8b4b"
            />
            <path
              id="Path_402"
              data-name="Path 402"
              d="M10.484-21.628,4.913-2.755l10.794-9.573Z"
              transform="translate(336 -467)"
              fill="#d9782d"
            />
          </G>
        </G>
      </Svg>
    )
  }

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-UPI-Grey">
          <rect width={size} height={size} />
        </clipPath>
      </defs>
      <G id="UPI-Grey" clip-path="url(#clip-UPI-Grey)">
        <G id="UPI-grey-2" data-name="UPI-grey" transform="translate(-336 491)">
          <path
            id="Path_401"
            data-name="Path 401"
            d="M10.484-21.628,4.913-2.755l10.794-9.573Z"
            transform="translate(340 -467)"
            fill="#7b7d80"
          />
          <path
            id="Path_402"
            data-name="Path 402"
            d="M10.484-21.628,4.913-2.755l10.794-9.573Z"
            transform="translate(336 -467)"
            fill="#b6b8b9"
          />
        </G>
      </G>
    </Svg>
  )
}
